import { attributeValues } from './attributes';

// Returns StimulusReflex controllers local to the passed element based on the data-controller attribute.
//
var localReflexControllers = function localReflexControllers(app, element) {
  return attributeValues(element.getAttribute(app.schema.controllerAttribute)).reduce(function (memo, name) {
    var controller = app.getControllerForElementAndIdentifier(element, name);
    if (controller && controller.StimulusReflex) memo.push(controller);
    return memo;
  }, []);
};

// Returns all StimulusReflex controllers for the passed element.
// Traverses DOM ancestors starting with element.
//
export var allReflexControllers = function allReflexControllers(app, element) {
  var controllers = [];
  while (element) {
    controllers = controllers.concat(localReflexControllers(app, element));
    element = element.parentElement;
  }
  return controllers;
};